export const RegionalDistributorWarningTranslations = {
  distributorRegionalPlanningInfo: 'jbp-distributor-regional-planning-info',
  distributorGroupPlanningIFnfo: 'jbp-distributor-group-planning-info',
}

export default RegionalDistributorWarningTranslations
